
export default class RenderPipeline {
  pipeline: GPURenderPipeline | null = null;
  key: string;

  constructor(key: string) {
    this.key = key;
  }
}